<!-- 🔴 STANDARD MODAL HEADER STRUCTURE (SuperPrompt V6) -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Issue description if available -->
@if (ISSUE_DESC) {
<table cellspacing="1" cellpadding="1" style="width:100%">
  <tr style="height:50px;">
    <td style="width:20%"></td>
    <td style="width:20%"></td>
    <td style="width:20%"></td>
    <td style="width:20%"></td>
    <td style="width:20%;vertical-align:middle;text-align:left">
      <b>Issue: {{ISSUE_DESC}}</b>
    </td>
  </tr>
</table>
}

<!-- 🔴 STANDARD MODAL BODY STRUCTURE with TABS (like F7004) -->
<div class="modal-body" [hidden]="minimise">
  <!-- Tab navigation like F7004 -->
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id; assignTabNames(tab.name)" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active" style="overflow-y: auto; max-height: calc(90vh - 200px);">
      <div class="form-horizontal">
        <!-- Loader -->
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        <!-- Content when not loading -->
        @if (!showFormLoader) {
<div>
          <!-- 🔴 STANDARD ENTITY INFORMATION TABLE with BOLD labels (SuperPrompt V6) -->
          <table class="table table-bordered form-inline enityDetails custom-table">
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span><strong>{{ item.key }}</strong></span>
              </td>
}
            </tr>
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.value }}</span>
              </td>
}
            </tr>
          </table>

          <!-- Name and EIN fields with proper padding like AngularJS -->
          <table class="table table-bordered form-inline name-ein-table">
            <tr>
              <td>{{scheduleFFormView.rows[1]?.description}}:
                <div>   
                  <input class="form-control input-md numText text_field_width" 
                         type="text" 
                         maxlength="19" 
                         [ngModel]="scheduleFFormView.rows[1]?.value1"
                         disabled 
                         aria-describedby="basic-addon2">
                </div>
              </td>
              <td>{{scheduleFFormView.rows[2]?.description}}
                <div>   
                  <input class="form-control input-md numText text_field_width" 
                         type="text" 
                         maxlength="10" 
                         [ngModel]="scheduleFFormView.rows[2]?.value1"
                         disabled 
                         aria-describedby="basic-addon2">
                </div>
              </td> 
            </tr>
          </table>

          <!-- Simple Schedule A Table -->
          <table class="table table-bordered">
            <thead>
              <tr>
                <th style="width: 80px;">Line</th>
                <th>Description</th>
                <th style="width: 200px;">Value</th>
              </tr>
            </thead>
            <tbody>
              <!-- 9a main question -->
              @if (scheduleFFormView.rows[11]) {
<tr>
                <td><strong>{{scheduleFFormView.rows[11].num}}</strong></td>
                <td colspan="2"><strong>{{scheduleFFormView.rows[11].description}}</strong></td>
              </tr>
}

              <!-- 9a(i) checkbox -->
              @if (scheduleFFormView.rows[12]) {
<tr>
                <td>(i)</td>
                <td>{{scheduleFFormView.rows[12].description}}</td>
                <td style="text-align: center;">
                  <input type="checkbox" 
                         [checked]="scheduleFFormView.rows[12].value1 === 'true'"
                         (change)="onCheckboxChange($event, 12)">
                </td>
              </tr>
}

              <!-- 9a(ii) checkbox -->
              @if (scheduleFFormView.rows[13]) {
<tr>
                <td>(ii)</td>
                <td>{{scheduleFFormView.rows[13].description}}</td>
                <td style="text-align: center;">
                  <input type="checkbox" 
                         [checked]="scheduleFFormView.rows[13].value1 === 'true'"
                         (change)="onCheckboxChange($event, 13)">
                </td>
              </tr>
}

              <!-- 9a(iii) checkbox with text input -->
              @if (scheduleFFormView.rows[14]) {
<tr>
                <td>(iii)</td>
                <td>{{scheduleFFormView.rows[14].description}} {{scheduleFFormView.rows[15]?.description}}</td>
                <td style="text-align: center;">
                  <input type="checkbox" 
                         [checked]="scheduleFFormView.rows[14].value1 === 'true'"
                         (change)="onCheckboxChange($event, 14)">
                  @if (scheduleFFormView.rows[15]) {
<div style="margin-top: 10px;">
                    <input class="form-control" 
                           type="text" 
                           [(ngModel)]="scheduleFFormView.rows[15].value1"
                           [disabled]="scheduleFFormView.rows[14].value1 !== 'true'"
                           style="width: 80%; margin: 0 auto;"
                           (input)="onNumericInput($event, scheduleFFormView.rows[15])"
                           (keypress)="allowOnlyNumeric($event)"
                           (paste)="onPaste($event, scheduleFFormView.rows[15])"
                           (blur)="sanitizeNumericValue(scheduleFFormView.rows[15])"
                           pattern="[0-9\-\.]+"
                           title="Please enter numbers only">
                  </div>
}
                </td>
              </tr>
}

              <!-- 9b checkbox -->
              @if (scheduleFFormView.rows[16]) {
<tr>
                <td>9b</td>
                <td>{{scheduleFFormView.rows[16].description}}</td>
                <td style="text-align: center;">
                  <input type="checkbox" 
                         [checked]="scheduleFFormView.rows[16].value1 === 'true'"
                         (change)="onCheckboxChange($event, 16)">
                </td>
              </tr>
}

              <!-- 9c checkbox -->
              @if (scheduleFFormView.rows[17]) {
<tr>
                <td>9c</td>
                <td>{{scheduleFFormView.rows[17].description}}</td>
                <td style="text-align: center;">
                  <input type="checkbox" 
                         [checked]="scheduleFFormView.rows[17].value1 === 'true'"
                         (change)="onCheckboxChange($event, 17); clickLine17()">
                </td>
              </tr>
}

              <!-- 9d text input -->
              @if (scheduleFFormView.rows[18]) {
<tr>
                <td>9d</td>
                <td>{{scheduleFFormView.rows[18].description}}</td>
                <td style="text-align: center;">
                  <input class="form-control" 
                         type="text" 
                         [(ngModel)]="scheduleFFormView.rows[18].value1"
                         [disabled]="scheduleFFormView.rows[17].value1 !== 'true'"
                         style="width: 80%; margin: 0 auto;"
                         (input)="onNumericInput($event, scheduleFFormView.rows[18])"
                         (keypress)="allowOnlyNumeric($event)"
                         (paste)="onPaste($event, scheduleFFormView.rows[18])"
                         (blur)="sanitizeNumericValue(scheduleFFormView.rows[18])"
                         pattern="[0-9\-\.]+"
                         title="Please enter numbers only">
                </td>
              </tr>
}

              <!-- 9e radio buttons -->
              @if (scheduleFFormView.rows[19]) {
<tr>
                <td>9e</td>
                <td>{{scheduleFFormView.rows[19].description}}</td>
                <td style="text-align: center;">
                  <input type="radio" 
                         name="line_e_radio" 
                         [checked]="scheduleFFormView.rows[19].value1 === 'true'"
                         (change)="onRadioChange(19, true, scheduleFFormView.rows[19])"> Yes &nbsp;&nbsp;
                  <input type="radio" 
                         name="line_e_radio" 
                         [checked]="scheduleFFormView.rows[20]?.value1 === 'true'"
                         (change)="onRadioChange(20, true, scheduleFFormView.rows[20])"> No
                </td>
              </tr>
}

              <!-- 9f radio buttons -->
              @if (scheduleFFormView.rows[21]) {
<tr>
                <td>9f</td>
                <td>{{scheduleFFormView.rows[21].description}}</td>
                <td style="text-align: center;">
                  <input type="radio" 
                         name="line_f_radio" 
                         [checked]="scheduleFFormView.rows[21].value1 === 'true'"
                         (change)="onRadioChange(21, true, scheduleFFormView.rows[21])"> Yes &nbsp;&nbsp;
                  <input type="radio" 
                         name="line_f_radio" 
                         [checked]="scheduleFFormView.rows[22]?.value1 === 'true'"
                         (change)="onRadioChange(22, true, scheduleFFormView.rows[22])"> No
                </td>
              </tr>
}
            </tbody>
          </table>
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- 🔴 STANDARD FOOTER STRUCTURE (SuperPrompt V6) -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
